const prefetchMap: Record<string, () => Promise<unknown>> = {
  '/': () => import('../pages/Home'),
  '/islands': () => import('../pages/Islands'),
  '/regions': () => import('../pages/Regions'),
  '/locations': () => import('../pages/Locations'),
  '/national-parks': () => import('../pages/NationalParks'),
  '/guides': () => import('../pages/TravelGuides'),
  '/camping': () => import('../pages/Camping'),
  '/sailing': () => import('../pages/Sailing'),
  '/best-time': () => import('../pages/BestTimeToVisit'),
  '/budget-calculator': () => import('../pages/BudgetCalculator'),
  '/compare': () => import('../pages/Compare'),
  '/itinerary': () => import('../pages/Itinerary'),
  '/favorites': () => import('../pages/Favorites'),
  '/festivals': () => import('../pages/Festivals'),
  '/airports': () => import('../pages/Airports'),
  '/itinerary-guides': () => import('../pages/ItineraryGuides'),
  '/day-trips': () => import('../pages/DayTrips'),
  '/ferry-routes': () => import('../pages/FerryRoutes'),
  '/packing-list': () => import('../pages/PackingList'),
  '/webcams': () => import('../pages/Webcams'),
  '/map': () => import('../pages/MapExplorer'),
  '/hiking': () => import('../pages/Hiking'),
  '/about': () => import('../pages/About'),
};

const prefetched = new Set<string>();

export function prefetchRoute(path: string): void {
  const basePath = ('/' + path.replace(/^\/(de|fr|it|nl|hr|pl|en)\//, '').replace(/^\/(de|fr|it|nl|hr|pl|en)$/, '')).replace(/\/+/g, '/') || '/';
  if (prefetched.has(basePath)) return;
  const prefetcher = Object.prototype.hasOwnProperty.call(prefetchMap, basePath) ? prefetchMap[basePath] : undefined;
  if (prefetcher) {
    prefetched.add(basePath);
    prefetcher().catch(() => {});
  }
}
